var _defs, _path, _path2, _path3, _ellipse, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBranding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_576",
    "data-name": "Grupo 576",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 180.128,
    height: 184.374,
    viewBox: "0 0 180.128 184.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7a90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24748a"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_896",
    "data-name": "Trazado 896",
    d: "M110.625,336.673l66.5-149.935a6.429,6.429,0,0,1,8.474-3.267l48.694,21.6a6.429,6.429,0,0,1,3.267,8.474l-66.5,149.935a6.429,6.429,0,0,1-8.474,3.267l-48.694-21.6A6.429,6.429,0,0,1,110.625,336.673Z",
    transform: "translate(-110.075 -182.92)",
    fill: "#fff",
    opacity: 0.26
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_897",
    "data-name": "Trazado 897",
    d: "M110.625,336.673l66.5-149.935a6.429,6.429,0,0,1,8.474-3.267l48.694,21.6a6.429,6.429,0,0,1,3.267,8.474l-66.5,149.935a6.429,6.429,0,0,1-8.474,3.267l-48.694-21.6A6.429,6.429,0,0,1,110.625,336.673Zm125.9-123.59a5.3,5.3,0,0,0-2.692-6.983l-48.694-21.6a5.3,5.3,0,0,0-6.983,2.692l-66.5,149.935a5.3,5.3,0,0,0,2.692,6.983l48.694,21.6a5.3,5.3,0,0,0,6.983-2.692Z",
    transform: "translate(-110.075 -182.92)",
    fill: "#95989a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_898",
    "data-name": "Trazado 898",
    d: "M24.882,0A24.882,24.882,0,1,1,0,24.882,24.882,24.882,0,0,1,24.882,0Z",
    transform: "translate(48.356 42.682)",
    fill: "#faf8f8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_102",
    "data-name": "Elipse 102",
    cx: 24.882,
    cy: 24.882,
    rx: 24.882,
    ry: 24.882,
    transform: "translate(36.25 69.975)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_899",
    "data-name": "Trazado 899",
    d: "M155.924,355.664A24.882,24.882,0,1,1,176.1,310.172c12.562,5.571,26.337,34.146,12.658,32.834C173.093,341.5,168.487,361.235,155.924,355.664Z",
    transform: "translate(-116.985 -210.766)",
    fill: "url(#linear-gradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_575",
    "data-name": "Grupo 575",
    transform: "translate(106.461 28.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_900",
    "data-name": "Trazado 900",
    d: "M841.862,472.283l-.895-11.965v-.008l-.45-6.01a36.065,36.065,0,0,0-11.88-24.217l-.093-.078-.008-.008L807.2,410.772a1.757,1.757,0,0,0-2.146-.194,1.727,1.727,0,0,0-.759.967,6.205,6.205,0,0,1,2.009,8.28l.685,2.438v.008c7.117,5.315,8.853,13.319,6.539,23.346l.047.156-.078-.132c-9.143-5.438-14.611-12.6-13.683-22.763a6.208,6.208,0,0,1-4.991-7.411,1.7,1.7,0,0,0-.506-.077,1.606,1.606,0,0,0-.466.062,1.754,1.754,0,0,0-1.329,1.687l-.653,29.216a35.154,35.154,0,0,0,9.353,24.746l2.41,2.6,10.005,10.838,8.933,9.679,17.1-7.424.008-.008,3.156-1.368Z",
    transform: "translate(-782.45 -370.457)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_901",
    "data-name": "Trazado 901",
    d: "M611.725,245.694l-.373.14-1.081.42-2.13-5.535-8.583-22.3-.016-.031-3.841-10h-.008l-1.228-3.2,1.454-.56,1.337,3.467,12.455,32.38Z",
    transform: "translate(-591.909 -200.606)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_902",
    "data-name": "Trazado 902",
    d: "M785.19,366.5a.39.39,0,0,1-.085.031,3.912,3.912,0,0,1-1.555.3h-.008a3.989,3.989,0,0,1-1.415-.311,3.892,3.892,0,0,1-2.045-2.029,3.842,3.842,0,0,1-.272-2.193,3.892,3.892,0,0,1,7.129-1.43,3.7,3.7,0,0,1,.272.521,3.886,3.886,0,0,1-2.021,5.116Z",
    transform: "translate(-779.755 -359.052)",
    fill: "#ef7a90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_903",
    "data-name": "Trazado 903",
    d: "M806.882,418.913a.224.224,0,0,1-.03.066v.006a4.513,4.513,0,0,1-.635,1.007,4.809,4.809,0,0,1-4.25,1.727v-.006a4.784,4.784,0,0,1-3.848-2.853,4.717,4.717,0,0,1-.318-2.793,4.774,4.774,0,0,1,2.8-3.513c.084-.036.174-.072.258-.1.1-.036.2-.072.306-.1a4.984,4.984,0,0,1,.869-.174,3.321,3.321,0,0,1,.342-.018,4.64,4.64,0,0,1,2,.378,4.85,4.85,0,0,1,1.091.635v.006a4.043,4.043,0,0,1,.455.4v.006a4.874,4.874,0,0,1,.989,1.463,4.757,4.757,0,0,1-.03,3.872Z",
    transform: "translate(-783.753 -370.87)",
    fill: "#ef7a90"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_103",
    "data-name": "Elipse 103",
    cx: 3.11,
    cy: 3.11,
    rx: 3.11,
    ry: 3.11,
    transform: "translate(29.531 74.746)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_904",
    "data-name": "Trazado 904",
    d: "M830.423,525.215a5.7,5.7,0,0,1-5.276-3.386l-.052-.118a8.438,8.438,0,0,1-.585-4.833l-1.988.864a8.553,8.553,0,0,1-11.314-4.583,8.735,8.735,0,0,1,4.745-11.212c5.568-12.858,15.777-17.965,31.582-13.724a8.72,8.72,0,0,1,11.264,3.81h0a8.483,8.483,0,0,1,.454,6.8,8.586,8.586,0,0,1-4.646,4.968l-1.987.863a8.442,8.442,0,0,1,3.134,3.725q.143.329.256.663a5.678,5.678,0,0,1-1.6,6.084,5.892,5.892,0,0,1-6.439,1.081,8.846,8.846,0,0,0-3.548-.757h-.044a9.5,9.5,0,0,0-8.378,5.979,5.9,5.9,0,0,1-5.428,3.778Z",
    transform: "translate(-786.623 -387.474)",
    fill: "#221e1d",
    stroke: "#faf8f8",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranding);
export default __webpack_public_path__ + "static/media/branding.bd69e5d8ce9b6dac8167596934a6b787.svg";
export { ForwardRef as ReactComponent };